import React from "react";

import AvatarCard from "./components/AvatarCard";
import InfoWrapper from "./components/InfoWrapper";
import SummaryCard from "./components/SummaryCard";
import SkillsCard from "./components/SkillsCard";

const App = () => {
  return (
    <div className="container mx-auto mt-10 flex flex-col justify-center lg:flex-row lg:gap-x-10 lg:gap-y-5">
      <AvatarCard />
      <InfoWrapper>
        <SummaryCard />
        <SkillsCard />
      </InfoWrapper>
    </div>
  );
};

export default App;
